/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const mczv1UpdateUser = /* GraphQL */ `
  mutation Mczv1UpdateUser($input: UpdateMCZV1UserInput!) {
    mczv1UpdateUser(input: $input) {
      id
      pk
      sk
      lsiStr1
      lsiStr2
      lsiStr3
      lsiStr4
      lsiInt1
      createdUser
      updatedUser
      modifiedAd
      groups
      tenant {
        tenantId
        name
        contractStart
        contractEnd
        maxCapacity
        maxProjects
        maxFiles
        maxUsers
        maxItemLists
        status
        allocateVolume
        numberOfProject
        availableOptions
      }
      user {
        name
        userId
        usertype
        campanyName
        status
        period
        email
        deleted
      }
      meeting {
        title
        roomId
        meetingId
        startDateTime
        invitedUsers
      }
      project {
        id
        name
        description
        users {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        members {
          userId
          authType
        }
      }
      rootItem {
        label
        id
        type
        path
        fileSize
      }
      treeData
      backImage {
        name
        filePath
        parameters
        inspectMasterId
        inspectMasterList
        lineSetting {
          streetlineId
          lineType
          startX
          startY
          endX
          endY
          lineColor
          lineWidth
          lineName
          labelPosition
        }
      }
      inspectPlace {
        placeId
        name
        x
        y
        createUser
        inspectMasterId
        lineName
        iconId
      }
      ttl
      shape {
        shapeId
        shapeType
        coordinates
        lineColor
        lineWidth
        paintColor
        paintAlpha
        radius
        shapeText
        shapeTextSize
        shapeTextColor
      }
      inspectMaster {
        id
        name
        statusName
        displayName
        description
        iconSelectType
        inspectItemList {
          id
          name
          itemType
          required
          order
          defaultValue
          systemDateFlg
          items {
            id
            name
            isDefault
            order
          }
        }
        iconSetting {
          id
          name
          iconFilePath
          order
          isDefault
        }
        lockFlg
        order
      }
      inspectResultSet {
        id
        masterId
        inspectList {
          itemId
          value
          valueId
          name
          itemType
          required
          order
        }
        photoList {
          filePath
          order
          isWrite
          memo
        }
      }
      notice {
        id
        targetUsers
        type
        title
        content
        Readed
        needPushNotice
        completedPush
        linkedId
        sourceName
      }
      timestamp
      treeItem {
        label
        id
        type
        path
        fileSize
      }
      recently {
        id
        targetSk
        treePlace
      }
      noticestatus {
        flg
      }
      noticeSegment {
        id
      }
      customize {
        key
        memo
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createEqutServiceSetting = /* GraphQL */ `
  mutation CreateEqutServiceSetting(
    $input: CreateEqutServiceSettingInput!
    $condition: ModelEqutServiceSettingConditionInput
  ) {
    createEqutServiceSetting(input: $input, condition: $condition) {
      id
      iosMinVersion
      iosStoreUrl
      isMaintenance
      maintenanceText
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateEqutServiceSetting = /* GraphQL */ `
  mutation UpdateEqutServiceSetting(
    $input: UpdateEqutServiceSettingInput!
    $condition: ModelEqutServiceSettingConditionInput
  ) {
    updateEqutServiceSetting(input: $input, condition: $condition) {
      id
      iosMinVersion
      iosStoreUrl
      isMaintenance
      maintenanceText
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteEqutServiceSetting = /* GraphQL */ `
  mutation DeleteEqutServiceSetting(
    $input: DeleteEqutServiceSettingInput!
    $condition: ModelEqutServiceSettingConditionInput
  ) {
    deleteEqutServiceSetting(input: $input, condition: $condition) {
      id
      iosMinVersion
      iosStoreUrl
      isMaintenance
      maintenanceText
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createEqutWebSession = /* GraphQL */ `
  mutation CreateEqutWebSession(
    $input: CreateEqutWebSessionInput!
    $condition: ModelEqutWebSessionConditionInput
  ) {
    createEqutWebSession(input: $input, condition: $condition) {
      id
      owner
      sessionId
      info
      _ttl
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateEqutWebSession = /* GraphQL */ `
  mutation UpdateEqutWebSession(
    $input: UpdateEqutWebSessionInput!
    $condition: ModelEqutWebSessionConditionInput
  ) {
    updateEqutWebSession(input: $input, condition: $condition) {
      id
      owner
      sessionId
      info
      _ttl
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteEqutWebSession = /* GraphQL */ `
  mutation DeleteEqutWebSession(
    $input: DeleteEqutWebSessionInput!
    $condition: ModelEqutWebSessionConditionInput
  ) {
    deleteEqutWebSession(input: $input, condition: $condition) {
      id
      owner
      sessionId
      info
      _ttl
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createEqutSetting = /* GraphQL */ `
  mutation CreateEqutSetting(
    $input: CreateEqutSettingInput!
    $condition: ModelEqutSettingConditionInput
  ) {
    createEqutSetting(input: $input, condition: $condition) {
      id
      tenantArn
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateEqutSetting = /* GraphQL */ `
  mutation UpdateEqutSetting(
    $input: UpdateEqutSettingInput!
    $condition: ModelEqutSettingConditionInput
  ) {
    updateEqutSetting(input: $input, condition: $condition) {
      id
      tenantArn
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteEqutSetting = /* GraphQL */ `
  mutation DeleteEqutSetting(
    $input: DeleteEqutSettingInput!
    $condition: ModelEqutSettingConditionInput
  ) {
    deleteEqutSetting(input: $input, condition: $condition) {
      id
      tenantArn
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createMCZV1 = /* GraphQL */ `
  mutation CreateMCZV1(
    $input: CreateMCZV1Input!
    $condition: ModelMCZV1ConditionInput
  ) {
    createMCZV1(input: $input, condition: $condition) {
      id
      pk
      sk
      lsiStr1
      lsiStr2
      lsiStr3
      lsiStr4
      lsiInt1
      createdUser
      updatedUser
      modifiedAd
      groups
      tenant {
        tenantId
        name
        contractStart
        contractEnd
        maxCapacity
        maxProjects
        maxFiles
        maxUsers
        maxItemLists
        status
        allocateVolume
        numberOfProject
        availableOptions
      }
      user {
        name
        userId
        usertype
        campanyName
        status
        period
        email
        deleted
      }
      meeting {
        title
        roomId
        meetingId
        startDateTime
        invitedUsers
      }
      project {
        id
        name
        description
        users {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        members {
          userId
          authType
        }
      }
      rootItem {
        label
        id
        type
        path
        fileSize
      }
      treeData
      backImage {
        name
        filePath
        parameters
        inspectMasterId
        inspectMasterList
        lineSetting {
          streetlineId
          lineType
          startX
          startY
          endX
          endY
          lineColor
          lineWidth
          lineName
          labelPosition
        }
      }
      inspectPlace {
        placeId
        name
        x
        y
        createUser
        inspectMasterId
        lineName
        iconId
      }
      ttl
      shape {
        shapeId
        shapeType
        coordinates
        lineColor
        lineWidth
        paintColor
        paintAlpha
        radius
        shapeText
        shapeTextSize
        shapeTextColor
      }
      inspectMaster {
        id
        name
        statusName
        displayName
        description
        iconSelectType
        inspectItemList {
          id
          name
          itemType
          required
          order
          defaultValue
          systemDateFlg
          items {
            id
            name
            isDefault
            order
          }
        }
        iconSetting {
          id
          name
          iconFilePath
          order
          isDefault
        }
        lockFlg
        order
      }
      inspectResultSet {
        id
        masterId
        inspectList {
          itemId
          value
          valueId
          name
          itemType
          required
          order
        }
        photoList {
          filePath
          order
          isWrite
          memo
        }
      }
      notice {
        id
        targetUsers
        type
        title
        content
        Readed
        needPushNotice
        completedPush
        linkedId
        sourceName
      }
      timestamp
      treeItem {
        label
        id
        type
        path
        fileSize
      }
      recently {
        id
        targetSk
        treePlace
      }
      noticestatus {
        flg
      }
      noticeSegment {
        id
      }
      customize {
        key
        memo
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateMCZV1 = /* GraphQL */ `
  mutation UpdateMCZV1(
    $input: UpdateMCZV1Input!
    $condition: ModelMCZV1ConditionInput
  ) {
    updateMCZV1(input: $input, condition: $condition) {
      id
      pk
      sk
      lsiStr1
      lsiStr2
      lsiStr3
      lsiStr4
      lsiInt1
      createdUser
      updatedUser
      modifiedAd
      groups
      tenant {
        tenantId
        name
        contractStart
        contractEnd
        maxCapacity
        maxProjects
        maxFiles
        maxUsers
        maxItemLists
        status
        allocateVolume
        numberOfProject
        availableOptions
      }
      user {
        name
        userId
        usertype
        campanyName
        status
        period
        email
        deleted
      }
      meeting {
        title
        roomId
        meetingId
        startDateTime
        invitedUsers
      }
      project {
        id
        name
        description
        users {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        members {
          userId
          authType
        }
      }
      rootItem {
        label
        id
        type
        path
        fileSize
      }
      treeData
      backImage {
        name
        filePath
        parameters
        inspectMasterId
        inspectMasterList
        lineSetting {
          streetlineId
          lineType
          startX
          startY
          endX
          endY
          lineColor
          lineWidth
          lineName
          labelPosition
        }
      }
      inspectPlace {
        placeId
        name
        x
        y
        createUser
        inspectMasterId
        lineName
        iconId
      }
      ttl
      shape {
        shapeId
        shapeType
        coordinates
        lineColor
        lineWidth
        paintColor
        paintAlpha
        radius
        shapeText
        shapeTextSize
        shapeTextColor
      }
      inspectMaster {
        id
        name
        statusName
        displayName
        description
        iconSelectType
        inspectItemList {
          id
          name
          itemType
          required
          order
          defaultValue
          systemDateFlg
          items {
            id
            name
            isDefault
            order
          }
        }
        iconSetting {
          id
          name
          iconFilePath
          order
          isDefault
        }
        lockFlg
        order
      }
      inspectResultSet {
        id
        masterId
        inspectList {
          itemId
          value
          valueId
          name
          itemType
          required
          order
        }
        photoList {
          filePath
          order
          isWrite
          memo
        }
      }
      notice {
        id
        targetUsers
        type
        title
        content
        Readed
        needPushNotice
        completedPush
        linkedId
        sourceName
      }
      timestamp
      treeItem {
        label
        id
        type
        path
        fileSize
      }
      recently {
        id
        targetSk
        treePlace
      }
      noticestatus {
        flg
      }
      noticeSegment {
        id
      }
      customize {
        key
        memo
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteMCZV1 = /* GraphQL */ `
  mutation DeleteMCZV1(
    $input: DeleteMCZV1Input!
    $condition: ModelMCZV1ConditionInput
  ) {
    deleteMCZV1(input: $input, condition: $condition) {
      id
      pk
      sk
      lsiStr1
      lsiStr2
      lsiStr3
      lsiStr4
      lsiInt1
      createdUser
      updatedUser
      modifiedAd
      groups
      tenant {
        tenantId
        name
        contractStart
        contractEnd
        maxCapacity
        maxProjects
        maxFiles
        maxUsers
        maxItemLists
        status
        allocateVolume
        numberOfProject
        availableOptions
      }
      user {
        name
        userId
        usertype
        campanyName
        status
        period
        email
        deleted
      }
      meeting {
        title
        roomId
        meetingId
        startDateTime
        invitedUsers
      }
      project {
        id
        name
        description
        users {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        members {
          userId
          authType
        }
      }
      rootItem {
        label
        id
        type
        path
        fileSize
      }
      treeData
      backImage {
        name
        filePath
        parameters
        inspectMasterId
        inspectMasterList
        lineSetting {
          streetlineId
          lineType
          startX
          startY
          endX
          endY
          lineColor
          lineWidth
          lineName
          labelPosition
        }
      }
      inspectPlace {
        placeId
        name
        x
        y
        createUser
        inspectMasterId
        lineName
        iconId
      }
      ttl
      shape {
        shapeId
        shapeType
        coordinates
        lineColor
        lineWidth
        paintColor
        paintAlpha
        radius
        shapeText
        shapeTextSize
        shapeTextColor
      }
      inspectMaster {
        id
        name
        statusName
        displayName
        description
        iconSelectType
        inspectItemList {
          id
          name
          itemType
          required
          order
          defaultValue
          systemDateFlg
          items {
            id
            name
            isDefault
            order
          }
        }
        iconSetting {
          id
          name
          iconFilePath
          order
          isDefault
        }
        lockFlg
        order
      }
      inspectResultSet {
        id
        masterId
        inspectList {
          itemId
          value
          valueId
          name
          itemType
          required
          order
        }
        photoList {
          filePath
          order
          isWrite
          memo
        }
      }
      notice {
        id
        targetUsers
        type
        title
        content
        Readed
        needPushNotice
        completedPush
        linkedId
        sourceName
      }
      timestamp
      treeItem {
        label
        id
        type
        path
        fileSize
      }
      recently {
        id
        targetSk
        treePlace
      }
      noticestatus {
        flg
      }
      noticeSegment {
        id
      }
      customize {
        key
        memo
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
